import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["searchField", "results"];
  static values = { replaceId: String };

  connect() {
    this.replaceElement = document.getElementById(this.replaceIdValue);
  }

  search() {
    clearTimeout(this.timeout);

    this.timeout = setTimeout(() => {
      if (this.searchFieldTarget.value.length > 1) {
        this.resultsTarget.classList.remove("hidden");
        if (this.replaceElement !== null) {
          this.replaceElement.classList.add("hidden");
        }
        this.resultsTarget.innerHTML = "Searching...";
        this.searchFieldTarget.form.requestSubmit();
      } else {
        this.goToInitialState();
      }
    }, 300);
  }

  cancel() {
    this.searchFieldTarget.value = "";
    this.goToInitialState();
  }

  goToInitialState() {
    this.resultsTarget.classList.add("hidden");
    if (this.replaceElement !== null) {
      this.replaceElement.classList.remove("hidden");
    }
  }

  disconnect() {
    clearTimeout(this.timeout);
  }
}
